import { render, staticRenderFns } from "./message-location.vue?vue&type=template&id=2a3d4e12&scoped=true"
import script from "./message-location.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-location.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-location.vue?vue&type=style&index=0&id=2a3d4e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d4e12",
  null
  
)

export default component.exports